import React from "react"
import Toggle from "react-toggle"
import SerialNumberListing from "./SerialNumberListing"
import { FormattedMessage } from "react-intl"
import { useMutation } from "react-query"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

type Props = {
    productId: string
    serialNumberTrackingEnabled: boolean
    onToggleCallback: () => void
}

const SerialNumberListingContainer = (props: Props) => {
    const { productId } = props

    const { mutate: updateProduct } = useMutation(() => {
        props.onToggleCallback()
        return AppContext.getApiClient().patch(`/products/${productId}`, {
            trackSerialNumber: !props.serialNumberTrackingEnabled
        })
    })

    return <>
        <div className="row ui-has-modules">
            <div className="col-12 d-flex p-4 ui-module">
                <Toggle
                    checked={props.serialNumberTrackingEnabled}
                    icons={false}
                    onChange={() => {
                        updateProduct()
                    }}
                />
                <span className="ml-3">
                    <FormattedMessage
                        id="product.serial_number.enable_tracking.label"
                        defaultMessage="Enable serial number tracking"
                    />
                </span>
            </div>
        </div>

        {props.serialNumberTrackingEnabled &&
            <SerialNumberListing productId={productId} />
        }
    </>
}

export default SerialNumberListingContainer



// WEBPACK FOOTER //
// ./src/product/serial-number/SerialNumberListingContainer.tsx